export default __webpack_public_path__ + "static/media/submit-button-location.3710930c.png";